import { Select } from '@bloomfieldrobotics/canopy';
import { useMemo } from 'react';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';

type Props = {
  value: string;
  onChange: (value: string) => void;
};

export const BerriesPerClusterSelect = ({ value, onChange }: Props) => {
  const { t } = useTranslation();

  const menuItems = useMemo(() => {
    const items = [
      { value: 'all', label: t('All') },
      {
        value: '10-',
        label: t('Under 10'),
      },
    ];

    const thresholds = [10, 20, 30, 40, 50, 60, 70, 80];

    items.push(
      ...thresholds.map((val) => ({
        value: `${val}+`,
        label: `${val}+`,
      }))
    );

    return items;
  }, [t]);

  return (
    <Select
      variant='minimal'
      value={value}
      onChange={onChange}
      options={menuItems}
    />
  );
};
